// store the information of promotions

export const PROMOTIONS = [
  {
    id: 0,
    name: 'Weekend Grand Buffet',
    image: 'https://github.com/vanessaaleung/ristorante-con-fusion-react/blob/master/public/assets/images/buffet.png?raw=true',
    label: 'New',
    price: '19.99',
    featured: true,
    description: 'Featuring mouthwatering combinations with a choice of five different salads, six enticing appetizers, six main entrees and five choicest desserts. Free flowing bubbly and soft drinks. All for just $19.99 per person'
  }
];